import { UserAuthorityType } from 'entities/user/module'
import userStore from 'entities/user/module/user-store'

import { UserApi } from 'shared/api/UserApi'
import { setLocalStore } from 'shared/lib/local-store'

const defaultUserAuthorityType: UserAuthorityType = 'BANK_CLIENT'

interface GetUserInfo {
  token: string
  device_id?: string
  userAuthorityType?: UserAuthorityType
}

export const getUserData = async ({
  token,
  device_id,
  userAuthorityType,
}: GetUserInfo) => {
  try {
    const { data: userData } = await UserApi.loginUser({
      token,
      device_id,
    })

    setLocalStore('mTravelToken', userData.data.access_token!)

    userStore.loginUser({
      ...userData.data.user_data,
      user_authority_type: userAuthorityType || defaultUserAuthorityType,
    })
  } catch (e) {
    new Error('[Error on auth user]')
  }
}

export const getUserByToken = async ({
  userAuthorityType,
}: Pick<GetUserInfo, 'userAuthorityType'>) => {
  try {
    const { data: userData } = await UserApi.getUser()

    userStore.loginUser({
      ...userData.data,
      user_authority_type: userAuthorityType || defaultUserAuthorityType,
    })
  } catch (e) {
    new Error('[Error on login user]')
  }
}

export const getUserFromInnerToken = async ({
  token,
  userAuthorityType,
}: GetUserInfo) => {
  try {
    const { data: userData } = await UserApi.loginInnerUser(token)

    setLocalStore('mTravelToken', userData.data.access_token!)

    userStore.loginUser({
      ...userData.data.user_data,
      user_authority_type: userAuthorityType || defaultUserAuthorityType,
    })
  } catch (e) {
    new Error('[Error on auth user]')
  }
}

export const isUserInWidgetSearch = () => {
  return location?.pathname?.split('_')?.length > 2
}
